const { REACT_APP_ENABLE_METADATA_FUNCTIONALITY } = process.env;

let isMetadataFunctionalityEnabledInApp = false;

if (REACT_APP_ENABLE_METADATA_FUNCTIONALITY?.toLowerCase() === 'true') {
  isMetadataFunctionalityEnabledInApp = true;
}
export default isMetadataFunctionalityEnabledInApp;
